import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { Role } from 'src/features/roles/utils/types';
import { RoleFormSchemaValues } from 'src/features/roles/utils/formSchema';

const RESOURCE = '/users/role/';

type MutationFnType = typeof mutationFn;
const mutationFn = (data: RoleFormSchemaValues): Promise<Role> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateRole };
